import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useClickOutside from '../hooks/use-click-outside';

function ModalContent({ className, onClickOutside, children }) {

    const contentRef = useRef(null);

    useClickOutside(contentRef, onClickOutside);

    const classes = [
        'webmed-modal',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div ref={contentRef} className={classes}>
            { children }
        </div>
    );

}

ModalContent.propTypes = {
    className: PropTypes.string,
    onClickOutside: PropTypes.func,
};

ModalContent.defaultProps = {
    className: '',
    onClickOutside: () => null,
};

export default ModalContent;
